import { Page } from '@pst/utils';
// import { loadingWrapper, openLinkByAnchor, Page, toast } from '@pst/utils';
// import $ from 'jquery';
// import { websiteTiming } from '../config/timing';
// import { getDownloadConfig } from '../services';

export const homePage = new Page({
  init() {
    // const url = new URL(window.location.href);
    // const now = url.searchParams.get('x_time') ? Number(url.searchParams.get('x_time')) : window.Date.now();
    // $('.download-pc').on(
    //   'click',
    //   loadingWrapper(async () => {
    //     openLinkByAnchor('https://pst.dailygn.com/dl');
    //     // const stop = () => toast('暂未开启，敬请期待');
    //     // // 这个时间点之前不可用
    //     // if (now < websiteTiming.onlinePCLauncher) {
    //     //   stop();
    //     //   return;
    //     // }
    //     // const downloadConfig = await getDownloadConfig();
    //     // // 如果下线了下载链接则不可用
    //     // if (now >= websiteTiming.onlinePCLauncher && now < websiteTiming.offlinePCLauncher) {
    //     //   if (downloadConfig?.pcLauncherQALink) {
    //     //     openLinkByAnchor(downloadConfig.pcLauncherQALink);
    //     //   } else {
    //     //     stop();
    //     //   }
    //     //   return;
    //     // }
    //     // // 如果没有配置官包链接则不可用
    //     // if (now >= websiteTiming.offlinePCLauncher) {
    //     //   if (downloadConfig?.pcLauncherCommunityLink) {
    //     //     openLinkByAnchor(downloadConfig.pcLauncherCommunityLink);
    //     //   } else {
    //     //     stop();
    //     //   }
    //     //   return;
    //     // }
    //   }) as () => void,
    // );
    // (() => {
    //   if (now >= websiteTiming.offlinePCLauncher) {
    //     $('.download-pc-title').text('关注社区官号');
    //   }
    // })();
    // getDownloadConfig().then((config) => {
    //   if (config?.pcLauncherText) {
    //     $('.download-pc-title').text(config.pcLauncherText);
    //   }
    // });
  },
});
